export default __webpack_public_path__ + "static/media/DA1.b135181b.png";